import { render } from "./CategoryFour.vue?vue&type=template&id=7f8eb7bc"
import script from "./CategoryFour.vue?vue&type=script&lang=ts"
export * from "./CategoryFour.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
